"use client";

import Link from "next/link";

import { brandProfile, type BrandProfile } from "./brand";
import { useCurrentBrand } from "./useCurrentBrand";

/**
 * Reads the active brand off the `data-brand` attribute B1 established on
 * <html> and re-renders when it changes (reactive via useCurrentBrand — the
 * "brand switch works" test needs this to observe, not read once). Renders
 * a text wordmark from the hardcoded brand.ts profile; there are no logo
 * image assets yet (branding fixtures are held out, see brand.ts).
 */
function useBrandProfile(): BrandProfile {
  return brandProfile(useCurrentBrand());
}

interface BrandLogoProps {
  href?: string;
  className?: string;
}

export function BrandLogo({ href, className }: BrandLogoProps) {
  const profile = useBrandProfile();

  const mark = (
    <span className={className ?? "text-lg font-semibold tracking-tight text-ink"}>
      {profile.shortName}
      <span className="sr-only"> — {profile.name}</span>
    </span>
  );

  if (!href) return mark;

  return (
    <Link
      href={href}
      aria-label={`${profile.name} home`}
      className="rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-accent"
    >
      {mark}
    </Link>
  );
}
